import {
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroupProps,
} from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import { DEFAULT_TOGGLE_VALUE, TOGGLE_OPTIONS } from './options';
import styles from './index.module.scss';
import classNames from 'classnames';

interface IToggleRadioProps extends RadioGroupProps {
  name: string;
  label: string;
  control?: Control;
  classes?: {
    root?: string;
  };
}

const ToggleRadioField = ({ name, label, control, classes }: IToggleRadioProps) => {
  return (
    <FormControl>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <RadioGroup
            value={field.value}
            onChange={(event) => field.onChange(event.target.value === 'true')}
            defaultValue={DEFAULT_TOGGLE_VALUE}
            className={classNames(
              styles.radioFieldWrapper,
              classes?.root,
              'flex flex-col gap-4 w-full py-4',
            )}
          >
            <FormLabel className={styles.formLabel}>{label}</FormLabel>
            <div className={styles.radioLabelsWrapper}>
              {TOGGLE_OPTIONS.map(({ value, label }) => (
                <FormControlLabel
                  key={label}
                  className={styles.radioLabel}
                  control={
                    <Radio
                      value={value}
                      onChange={field.onChange}
                      classes={{
                        root: styles.radio,
                        checked: styles.checked,
                      }}
                    />
                  }
                  label={label}
                />
              ))}
            </div>
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};

export default ToggleRadioField;
